import { FormMode } from '../../enums/FormMode'

export const resolvePattern = (mode: FormMode) => {
  return mode === FormMode.READ ? 'readPretty' : 'editable'
}
